import React, { useEffect, useRef } from "react"
import Utils from "../../libs/Utils"
import Button from "../Button/Button"
import GUI, { IGUIProps } from "../GUI"

export type ESnackbarTypes = "error"|"info"|"warning"

export type TSnackbarProps = IGUIProps & {
    id:string
    title:any
    msg:string
    type:ESnackbarTypes
    duration:number
    onDismiss?:Function
}

export default function(props:TSnackbarProps) {
    const timeout = useRef<any>()
    
    let title:JSX.Element|string|null
    let msg:JSX.Element|string|null = null
    if (props.title && props.title instanceof Object){
        const e = Utils.errorMsg(props.title)
        title = e.title
        msg = e.message
    }
    else if (typeof(props.title)=="string") title = props.title
    else title = null
    
    if (!msg && typeof(props.msg)=="string") msg = props.msg

    useEffect(() => {
        timeout.current = setTimeout(onClick, props.duration)
        return () => { clearTimeout(timeout.current) }
    }, [])

    const onClick = (e:React.MouseEvent) => props.onDismiss?.()
    const onPointerDown = (e:React.PointerEvent) => e.stopPropagation()
    const onEnter = (e:React.PointerEvent) => clearTimeout(timeout.current)
    const onLeave = (e:React.PointerEvent) => timeout.current = setTimeout(onClick, props.duration)
    return <div className={GUI.joinClass("content", props.className, props.type)} onPointerDown={onPointerDown} onPointerEnter={onEnter} onPointerLeave={onLeave}>
        {title ? <h4>{title}</h4> : null}
        {msg ? <p>{msg}</p> : null}
        <div className="actions">
            <Button className="primary" onClick={onClick}>Ok</Button>
        </div>
    </div>
}